import { ChatChannelElementProps } from 'interfaces/ChatChannelElementProps';
import { Action } from 'redux';

import { ChannelActionType, SetAllChannelsAction } from './channels.actions';

const initialState = {
    allChannels: [] as ChatChannelElementProps[],
};

export const channelsReducer = (
    state = initialState,
    action: Action<ChannelActionType>,
): typeof initialState => {
    switch (action.type) {
        case ChannelActionType.SetAllChannels:
            const allChannels = (action as SetAllChannelsAction).payload;
            return { ...state, allChannels };

        default:
            return state;
    }
};
